import {LabelWithoutJson} from '@/components/atoms'
import {COLOR_CODE} from '@/utils/constants/colors'
import {FONT_SIZE, FONT_WEIGHT} from '@/utils/constants/globalStyle'

export const LabelWithVal = ({keyName, val}) => {
  const id = keyName?.toLowerCase()?.replaceAll(' ', '_') ?? ''
  return (
    <div className="col-4 w-full overflow-hidden pt-5">
      <div>
        <LabelWithoutJson
          id={`${id}_label`}
          text={keyName}
          fontWeight={FONT_WEIGHT.NORMAL}
          fontSize={FONT_SIZE.XS}
          className="font-body"
        />
        <LabelWithoutJson
          id={`${id}_value`}
          text={val ?? '-'}
          isValueDiasbledInput={false}
          fontWeight={FONT_WEIGHT.BOLD}
          fontSize={FONT_SIZE.SM}
          className="font-body"
          color={COLOR_CODE._FFFFFF}
        />
      </div>
    </div>
  )
}
